// extracted by mini-css-extract-plugin
export default {"element":"InfoBox-module--element--d0d5c","container":"InfoBox-module--container--6c6a2","list":"InfoBox-module--list--273bb"};